__turbopack_context__.v({
  "review-comments-star": "OiLapq_review-comments-star",
  "review-comments-title": "OiLapq_review-comments-title",
  "review-layout": "OiLapq_review-layout",
  "review-layout-mobile": "OiLapq_review-layout-mobile",
  "review-loadmore": "OiLapq_review-loadmore",
  "review-modal-body": "OiLapq_review-modal-body",
  "review-modal-heading": "OiLapq_review-modal-heading",
  "reviews-comments-star": "OiLapq_reviews-comments-star",
  "reviews-modal": "OiLapq_reviews-modal",
  "reviews-title-mobile": "OiLapq_reviews-title-mobile",
});
